import React, {Component} from 'react';
import styles from './RichTextStyles';
import {normalizeIndex} from './RichTextUtils';

export class SuggestionList extends Component {
	render() {
		const {suggestionsState} = this.props;
		const {left, top, array, selectedIndex} = suggestionsState;

		const style = Object.assign({}, styles.suggestions, {
			position: 'fixed',
			zIndex: 100000,
			left,
			top,
		});
		if (!array) {
			return null;
		}
		const normalizedIndex = normalizeIndex(selectedIndex, array.length);
		return (
			<ul style={style}>
				{array.map((person, index) => {
					const style = index === normalizedIndex ? styles.selectedPerson : styles.person;
					return (
						<li key={person.id} style={style}>
							{person.avatar ? <img style={{marginRight: '4px'}} crossOrigin="use-credentials" alt="" src={person.avatar} height={20} /> : null}
							<span>{person.name}</span>
						</li>
					);
				})}
			</ul>
		);
	}
}

export default SuggestionList;
